import BaseService from "./BaseService";
export default class AdminManagementService extends BaseService {
    static async getGroups(params = {}) {
        const res = await this.get(`/groups`, params, "ADMIN");
        return res.data;
    }
}
